import React, { useState } from "react";
import { missionAPI } from '../../services/api';

function MissionForm({ onSubmitSuccess }) {
  const [formData, setFormData] = useState({
    type: "",
    title: "",
    amount: "",
    kpis: [""],
    description: "",
    links: [""],
    otherDetails: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      console.log('Submitting mission:', formData);
      const response = await missionAPI.create(formData);
      console.log('Mission created:', response.data);
      onSubmitSuccess();
    } catch (error) {
      console.error('Error creating mission:', error);
      setError(error.message || 'Failed to create mission');
    } finally {
      setLoading(false);
    }
  };

  const addKPI = () => {
    setFormData({
      ...formData,
      kpis: [...formData.kpis, ""]
    });
  };

  const addLink = () => {
    setFormData({
      ...formData,
      links: [...formData.links, ""]
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="block mb-2 font-medium">Type of Mission</label>
        <select
          className="w-full p-2 border rounded focus:ring-2 focus:ring-indigo-500"
          value={formData.type}
          onChange={(e) => setFormData({...formData, type: e.target.value})}
          required
        >
          <option value="">Select Type</option>
          <option value="Mission Requests">Mission Requests</option>
          <option value="Bug Bounties">Bug Bounties</option>
          <option value="Hackathons">Hackathons</option>
          <option value="RetroPGF">RetroPGF</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div>
        <label className="block mb-2 font-medium">Title</label>
        <input
          type="text"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-indigo-500"
          value={formData.title}
          onChange={(e) => setFormData({...formData, title: e.target.value})}
          required
        />
      </div>

      <div>
        <label className="block mb-2 font-medium">Amount of Funds</label>
        <input
          type="number"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-indigo-500"
          value={formData.amount}
          onChange={(e) => setFormData({...formData, amount: e.target.value})}
          required
        />
      </div>

      <div>
        <label className="block mb-2 font-medium">KPIs</label>
        {formData.kpis.map((kpi, index) => (
          <div key={index} className="flex gap-2 mb-2">
            <input
              type="text"
              className="flex-1 p-2 border rounded focus:ring-2 focus:ring-indigo-500"
              value={kpi}
              onChange={(e) => {
                const newKPIs = [...formData.kpis];
                newKPIs[index] = e.target.value;
                setFormData({...formData, kpis: newKPIs});
              }}
              placeholder="Enter KPI"
            />
          </div>
        ))}
        <button
          type="button"
          onClick={addKPI}
          className="text-indigo-600 hover:text-indigo-800 text-sm"
        >
          + Add KPI
        </button>
      </div>

      <div>
        <label className="block mb-2 font-medium">Description</label>
        <textarea
          className="w-full p-2 border rounded focus:ring-2 focus:ring-indigo-500"
          rows="4"
          value={formData.description}
          onChange={(e) => setFormData({...formData, description: e.target.value})}
          required
        />
      </div>

      <div>
        <label className="block mb-2 font-medium">Links</label>
        {formData.links.map((link, index) => (
          <div key={index} className="flex gap-2 mb-2">
            <input
              type="url"
              className="flex-1 p-2 border rounded focus:ring-2 focus:ring-indigo-500"
              value={link}
              onChange={(e) => {
                const newLinks = [...formData.links];
                newLinks[index] = e.target.value;
                setFormData({...formData, links: newLinks});
              }}
              placeholder="https://"
            />
          </div>
        ))}
        <button
          type="button"
          onClick={addLink}
          className="text-indigo-600 hover:text-indigo-800 text-sm"
        >
          + Add Link
        </button>
      </div>

      <div>
        <label className="block mb-2 font-medium">Other Details</label>
        <textarea
          className="w-full p-2 border rounded focus:ring-2 focus:ring-indigo-500"
          rows="4"
          value={formData.otherDetails}
          onChange={(e) => setFormData({...formData, otherDetails: e.target.value})}
        />
      </div>

      {error && (
        <div className="text-red-500 text-sm">{error}</div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full bg-indigo-600 text-white py-2 px-4 rounded hover:bg-indigo-700 disabled:bg-gray-400"
      >
        {loading ? 'Creating Mission...' : 'Submit Mission'}
      </button>
    </form>
  );
}

export default MissionForm; 